import ArquivoPage from './arquivo.page'

export default ArquivoPage
